import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import AddSevak from "./AddSevak";
import SevakListGroup from "./SevakListGroup";
// import BookingHistory from "./BookingHistory";

const SevaDashboard = () => {
  const [activeView, setActiveView] = useState("addSevak");

  const renderContent = () => {
    switch (activeView) {
      case "addSevak":
        return <AddSevak />;
      case "groupList":
        return <SevakListGroup />;
      case "bookingHistory":
      // return <BookingHistory />;
      default:
        return <AddSevak />;
    }
  };

  return (
    <Container fluid className="mt-3">
      <Row>
        {/* Sidebar */}
        <Col md={3} className="bg-light p-3">
          <h5>Agent Panel</h5>
          <Button
            variant="outline-primary"
            className="w-100 mb-2"
            onClick={() => setActiveView("addSevak")}
          >
            ➕ Add Sevak
          </Button>
          <Button
            variant="outline-primary"
            className="w-100 mb-2"
            onClick={() => setActiveView("groupList")}
          >
            📋 Groups List
          </Button>
          <Button
            variant="outline-primary"
            className="w-100"
            // onClick={() => setActiveView("bookingHistory")}
          >
            📖 Booking History
          </Button>
        </Col>

        {/* Main Content */}
        <Col md={9} className="p-3">
          {renderContent()}
        </Col>
      </Row>
    </Container>
  );
};

export default SevaDashboard;
